import { combineReducers } from '@reduxjs/toolkit';
import {
    googleReducer,
    INITIAL_STATE as googleInitialState
} from 'app/store/integrations/google/reducer.js';
import {
    slackReducer,
    INITIAL_STATE as slackInitialState
} from 'app/store/integrations/slack/reducer.js';

export const INITIAL_STATE = {
    google: googleInitialState,
    slack: slackInitialState
};

export const integrationsReducer = combineReducers({
    google: googleReducer,
    slack: slackReducer
});
